import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { ActivityAction, ActivityGetter } from '@/store/activity/activity.module';
import { Activity } from '@/store/activity/activity.model';
import { Province } from '@/store/province/province.model';
import LoadingComponent from '@/components/loading/Loading.vue';
import _ from 'lodash';

export default defineComponent({
  name: 'InspectionPage',
  components: {
    LoadingComponent,
  },
  setup: () => {
    const router = useRouter();
    const dateFormat = useDateFormat();
    const store = useStore();
    const activities = computed<Activity[]>(() => {
      const acts = store.getters[ActivityGetter.ALL] as Activity[];
      return _.chain(acts)
        .orderBy(m => m.startDate, 'desc')
        .value();
    });
    const isLoading = computed(() => store.getters[ActivityGetter.STATUS] === 'init' || store.getters[ActivityGetter.STATUS] === 'loading');
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();

    onMounted(() => {
      store.dispatch(ActivityAction.FETCH)
        .then(() => initialDataTable());
    });

    const activityClick = (activityId: number) => {
      router.push(`/activity/${activityId}`);
    };

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const initialDataTable = () => {
      const dt = datatable.value as HTMLTableElement;
        if (!$.fn.dataTable.isDataTable(dt)) {
        dtInstance.value = $(dt).DataTable({
          language: {
            emptyTable: 'ไม่พบข้อมูล',
            info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
            infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
            infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
            lengthMenu: 'แสดงข้อมูล _MENU_',
            paginate: {
              next: 'ถัดไป',
              previous: 'ก่อนหน้า',
              first: 'First',
              last: 'Last'
            },
            search: 'ค้นหา:',
            zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
          }
        });
        }
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'short');

    const provincesHtml = (provinces: Province[]) => {
      return provinces.reduce((str, m) => `${str}<span class="badge bg-primary rounded-pill me-1">${m.name}</span>`, '');
    };

    return {
      activities,
      datatable,
      isLoading,
      activityClick,
      thaiDate,
      provincesHtml,
    };
  },
});
